import React, { useEffect, useRef } from "react";
import { mapConfig } from "../../../constant";
import { useState } from "react";
import {
  Autocomplete,
  DrawingManager,
  GoogleMap,
  Polygon,
} from "@react-google-maps/api";

const MapComponent = ({ setAlarm, alarm }) => {
  const autocompleteRef = useRef();
  const mapRef = useRef(null);
  const [map, setMap] = useState(null);
  const [coordinates, setCoordinates] = useState([]);
  const [PolylineVisible, setPolylineVisible] = useState(false);
  const [polygon, setPolygon] = useState(null);

  const autocompleteStyle = {
    boxSizing: "border-box",
    border: "1px solid transparent",
    width: "240px",
    height: "38px",
    padding: "0 12px",
    borderRadius: "3px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
    fontSize: "14px",
    color: "#000000",
    outline: "none",
    textOverflow: "ellipses",
    position: "absolute",
    right: "8%",
    top: "11px",
    marginLeft: "-120px",
  };

  const drawingOptions = {
    polygonOptions: {
      clickable: true,
      draggable: true,
      editable: true,
      fillColor: "#ADFF2F",
      fillOpacity: 0.5,
      strokeWeight: 2.5,
      strokeColor: "#CBC8C7",
    },
  };

  const handleSaveClick = () => {
    const commaSeparatedArray = coordinates.map((m) => `${m.lat()},${m.lng()}`);
    setAlarm((pre) => ({ ...pre, polygonCoordinates: commaSeparatedArray }));
  };

  const handleClearClick = () => {
    setPolylineVisible(false);
    setCoordinates([]);
  };

  const onLoad = React.useCallback(function callback(map) {
    // This is just an example of getting and using the map instance!!! don't just blindly copy!
    // const bounds = new window.google.maps.LatLngBounds(mapConfig.center);
    // map.fitBounds(bounds);
    setMap(map);
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  const onDragEnd = (e) => {
    const path = polygon.getPath().g;
    const newCoordinates = path.map((coord) => ({
      lat: coord.lat(),
      lng: coord.lng(),
    }));
    setCoordinates(newCoordinates);
  };

  useEffect(() => {
    if (map) {
      const polygonCoordinates = alarm.polygonCoordinates.map((coord) => {
        const [lat, lng] = coord.split(",");
        return new window.google.maps.LatLng(parseFloat(lat), parseFloat(lng));
      });
      if (polygonCoordinates && polygonCoordinates.length > 0) {
        setPolylineVisible(true);
        setCoordinates(polygonCoordinates);
        const bounds = new window.google.maps.LatLngBounds();
        polygonCoordinates.forEach((coord) => bounds.extend(coord));
        map.fitBounds(bounds);
      }
    }
  }, [alarm.polygonCoordinates, map]);

  const handlePloylineonload = (plygn) => {
    setPolygon(plygn);
  };

  const onLoadAutocomplete = (autocomplete) => {
    autocompleteRef.current = autocomplete;
  };

  const onPlaceChanged = () => {
    const { geometry } = autocompleteRef.current.getPlace();
    const bounds = new window.google.maps.LatLngBounds();
    if (geometry.viewport) {
      bounds.union(geometry.viewport);
    } else {
      bounds.extend(geometry.location);
    }
    map.fitBounds(bounds);
  };

  return (
    <div className="relative" style={{ height: "450px", width: "100%" }}>
      {/* {isLoaded ? ( */}
      <GoogleMap
        mapContainerStyle={{ height: "90%", width: "100%" }}
        center={mapConfig.center}
        zoom={mapConfig.zoom}
        onLoad={onLoad}
        options={{
          styles: mapConfig.styles,
          fullscreenControl: false,
          mapTypeControl: false,
          streetViewControl: false,
        }}
        onUnmount={onUnmount}
      >
        {/* Child components, such as markers, info windows, etc. */}
        {!PolylineVisible && (
          <DrawingManager
            drawingMode={window.google?.maps?.drawing?.OverlayType?.POLYGON}
            onOverlayComplete={({ overlay, type }) => {
              overlay.setMap(null); // this is important - it REMOVES the overlay from the map immediately
              setCoordinates(overlay.getPath().getArray());
              setPolylineVisible(true);
            }}
            options={{
              drawingControl: true,
              drawingControlOptions: {
                position: window.google?.maps?.ControlPosition?.TOP_CENTER,
                drawingModes: [
                  window.google?.maps?.drawing?.OverlayType?.POLYGON,
                ],
              },
              polygonOptions: drawingOptions.polygonOptions,
            }}
          />
        )}
        <Polygon
          paths={coordinates}
          editable={true}
          draggable={true}
          options={drawingOptions.polygonOptions}
          onMouseUp={onDragEnd}
          ref={mapRef}
          onLoad={handlePloylineonload}
          visible={PolylineVisible}
        />
        <Autocomplete
          onLoad={onLoadAutocomplete}
          onPlaceChanged={()=>onPlaceChanged()}
        >
          <input
            type="text"
            placeholder="Search Location"
            style={autocompleteStyle}
          />
        </Autocomplete>
      </GoogleMap>
      {/* ) : (
        <KendoLoadingPanel /> */}
      {/* )} */}
      <div className="flex justify-end gap-2 text-sm font-medium mt-2">
        <button
          onClick={() => handleClearClick()}
          className="bg-red-500 md:px-2 px-1 md:h-7 h-5 my-auto rounded"
        >
          Clear
        </button>
        <button
          className="bg-indigo-600 md:px-2 px-1 md:h-7 h-5 my-auto rounded disabled:opacity-30"
          disabled={coordinates.length === 0}
          onClick={() => handleSaveClick()}
        >
          Save Region
        </button>
      </div>
    </div>
  );
};

export default MapComponent;
